<div class="buy-again-list">
  @for (tradable of tradables; track tradable) {
    <div class="buy-again-list__tradable" (click)="onTradableClick.emit(tradable)">
      <svg width="48" height="48">
        <image
          [attr.xlink:href]="tradable.getLogo()"
          [attr.src]="tradable.getDefaultLogo()"
          width="48"
          height="48" />
      </svg>
    </div>
  }
</div>
